import React, { Fragment } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { history, store } from "../../../../store/store";
import { hideNotification } from '../../../../store/actions/notification';
import { ROUTE_CLIENT_EMAIL_CAMPAIGN_VIEW } from "../../../../config/routes";

function ViewEmailCampaign(props) {
  const { index, emailCampaign } = props;

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer mr-2 link-icon-color"
        id={`view-icon-${index}`}
        onClick={(e) => {
          e.preventDefault();
          store.dispatch(hideNotification());
          let url = ROUTE_CLIENT_EMAIL_CAMPAIGN_VIEW;
          url = url.replace( ":emailCampaignId", emailCampaign.id );
          history.push( url );
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="mr-2 cursor-pointer"
          pointerEvents="none"
          icon={faEye}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`view-icon-${index}`}
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: "body",
          },
        }}
      >
        <FormattedMessage id="button.view"/>
      </UncontrolledTooltip>
    </Fragment>
  );
}

export { ViewEmailCampaign };
